module.exports = __webpack_public_path__ + "static/media/ADANIENT_F1.678048d8.txt";